module.exports = __webpack_public_path__ + "img/onespring_logo.b6323612.svg";